/* bc-mega-menu.js — behavior for the native mega menu (replaces Globo).
   Desktop open/close/fade/hover-intent is pure CSS (:hover/:focus-within);
   this file only handles aria state, Escape, and the mobile drawer accordion. */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 990px)');

  /* ---------- desktop: hover-intent open state + Escape ----------
     The panel hangs off the header's bottom edge while the menu row sits a few
     px above it, so the pointer crosses a dead gap travelling down into the
     panel. :hover drops in that gap; .is-open bridges it — mouseleave arms a
     short grace timer, re-entering the item (the panel is a DOM child) cancels
     it. CSS keeps :hover as a no-JS fallback. */
  var GRACE_MS = 180;
  var megaItems = document.querySelectorAll('.bc-mm--desktop .bc-mm__item--mega');
  megaItems.forEach(function (li) {
    var target = li.querySelector('.bc-mm__target');
    if (!target) return;
    var closeTimer = null;
    var set = function (open) {
      li.classList.toggle('is-open', open);
      target.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    li._bcMmClose = function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      set(false);
    };
    li.addEventListener('mouseenter', function () {
      li.classList.remove('is-dismissed');
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      // only one panel at a time — snap siblings shut
      megaItems.forEach(function (other) {
        if (other !== li && other._bcMmClose) other._bcMmClose();
      });
      set(true);
    });
    li.addEventListener('mouseleave', function () {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        closeTimer = null;
        set(false);
      }, GRACE_MS);
    });
    li.addEventListener('focusin', function (e) {
      // after Escape, focus sits on the trigger: stay closed until the user moves or re-activates it
      if (li.classList.contains('is-dismissed') && e.target === target) return;
      li.classList.remove('is-dismissed');
      set(true);
    });
    // Enter / Space toggle the panel (the trigger has no href, so the browser does nothing on its own)
    target.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      if (li.classList.contains('is-open') && !li.classList.contains('is-dismissed')) {
        li.classList.add('is-dismissed'); li._bcMmClose();
      } else {
        li.classList.remove('is-dismissed');
        megaItems.forEach(function (other) { if (other !== li && other._bcMmClose) other._bcMmClose(); });
        set(true);
      }
    });
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) { li.classList.remove('is-dismissed'); set(false); }
    });
    li.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      li._bcMmClose();
      // keep focus (on the trigger, for keyboard users); .is-dismissed keeps :focus-within from re-opening the panel
      li.classList.add('is-dismissed');
      if (document.activeElement !== target) target.focus({ preventScroll: true });
    });
  });

  /* ---------- drawer: click accordion ---------- */
  document.querySelectorAll('.bc-mm--drawer .bc-mm__item--mega > .bc-mm__target').forEach(function (target) {
    target.addEventListener('click', function (e) {
      e.preventDefault();
      var li = target.parentElement;
      var open = li.classList.toggle('is-open');
      target.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* crossing the breakpoint clears accordion state */
  var onChange = function () {
    document.querySelectorAll('.bc-mm__item.is-open').forEach(function (li) {
      li.classList.remove('is-open');
      var t = li.querySelector('.bc-mm__target');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  };
  if (mq.addEventListener) mq.addEventListener('change', onChange);
  else if (mq.addListener) mq.addListener(onChange);
})();
